export default __webpack_public_path__ + "static/media/ma.4c691df4.svg";